export const HUTRIT_CLUB_UPLOAD_STEPS = {
  explications: 0,
  challengeTips: 1,
  successView: 2,
}

export const TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS = {
  instructions: 'Instrucciones',
  example: 'Ejemplo',
  delivery: 'Entrega',
}
